module.exports = __webpack_public_path__ + "img/252-european union.e673d091.svg";